import { ApiError } from './api';

/**
 * Plan ve kota yanıtlarının kullanıcı metni (M6 WP 6.1). `PLAN_LIMIT` de 403 döner ama "yetkiniz yok" DEĞİLDİR: form ve
 * eylem hata eşlemeleri 403'ü yetki metnine çevirmeden önce bu fonksiyona bakar. Sunucunun iletisi Türkçedir ve hangi
 * özelliğin kapalı ya da hangi tavanın dolu olduğunu söyler; ileti boşsa genel metin kullanılır. Plan/kota yanıtı
 * değilse `null` döner (çağıran kendi eşlemesine devam eder).
 */
export const PLAN_ERROR_TEXT = {
  storageFull:
    'Dosya depolama kotanız dolu; yeni dosya yüklenemiyor. Mevcut dosyalar görüntülenebilir ve indirilebilir. Yer açmak için dosya silebilir ya da kota artışı isteyebilirsiniz.',
  planLimit: 'Planınızın tavanına ulaşıldı; bu işlem yapılamıyor.',
};

export function planErrorText(e: unknown): string | null {
  if (!(e instanceof ApiError)) return null;
  if (e.code === 'STORAGE_FULL') return PLAN_ERROR_TEXT.storageFull;
  if (e.code === 'PLAN_LIMIT') return e.message.length > 0 ? e.message : PLAN_ERROR_TEXT.planLimit;
  return null;
}
